/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const TrendUpIconConfig = {
  name: 'TrendUpIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M1014.775 778.658c-1.515 4.432-4.569 8.071-8.581 10.306-10.48 10-24.361 15.858-38.546 15.554l-405.353-0.002c-14.944 0-29.575-5.915-40.16-16.501s-16.19-24.907-16.19-39.851v-46.697c-0.311-14.633 5.605-29.266 16.19-39.854 10.585-10.585 25.216-16.501 39.854-16.19l182.75-0.311-231.847-230.51-133.55 133.55c-7.769 7.769-19.721 7.769-27.493 0l-349.625-349.63 114.75-114.745 248.624 248.619 139.253-139.255c7.769-7.767 19.721-7.767 27.49 0l331.947 331.95 0.313-182.281c-0.313-14.633 5.605-29.269 16.19-39.854 10.587-10.587 25.216-16.503 40.162-16.503l46.699 0.002c14.631 0.311 28.953 5.913 39.538 16.498 10.587 10.587 16.501 25.218 16.811 39.856v405.355c0 10.898-3.326 21.461-9.227 30.491z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(TrendUpIconConfig);
//# sourceMappingURL=trend-up-icon.js.map